import styled from 'styled-components';
import IconThumbsDown from './IconThumbsDown';
var IconThumbsUp = /*#__PURE__*/styled(IconThumbsDown).withConfig({
  displayName: "IconThumbsUp",
  componentId: "c11n-8-111-1__sc-1ibwq0v-0"
})(["transform:scaleY(-1);"]);
export default IconThumbsUp;